import classNames from "classnames/dedupe";
import type { SkeletonProps } from "react-loading-skeleton";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { Section } from "../Section";
import { CardSkeleton as Control } from "./QuotesSkeleton";
import { CardSkeletonUK } from "./QuotesSkeletonUK";
import { variants } from "../variants";

export type QuotesSkeletonProps = {
  count?: number;
  variant?: string;
};

export const StyledSkeleton = (props: SkeletonProps) => (
  <Skeleton
    borderRadius="var(--radius-2)"
    {...props}
    containerClassName="mobius-skeleton"
  />
);

export const QuotesSkeleton = ({ count = 3, variant }: QuotesSkeletonProps) => {
  const isUKVariant = variants(variant);
  const classes = classNames("mobius-quote-cards__grid", {
    "--is-horizontal": isUKVariant,
  });

  return (
    <SkeletonTheme
      baseColor="var(--color-background-light)"
      highlightColor="var(--color-background)"
    >
      <Section data-variant={variant}>
        <ul className={classes}>
          {Array(count)
            .fill(undefined)
            .map((_, index) =>
              isUKVariant ? (
                <CardSkeletonUK key={index} />
              ) : (
                <Control key={index} />
              ),
            )}
        </ul>
      </Section>
    </SkeletonTheme>
  );
};
